import SearchPublishedContent from './SearchPublishedContent';

export default SearchPublishedContent;
